import React from 'react';
import { Box, Container, Grid } from "@mui/material";
import { useMenuData } from "../../../hooks/useMenuData";
import QuotingSubmenu from "./QuotingSubmenu";

const QuotingFooter = () => {
    const quotingFooterMenu = useMenuData('quoting_footer_menu');
    const quotingFooterData = quotingFooterMenu?.menu || [];

    return (
        <Box className={"quoting_footer"} sx={
            {
                backgroundColor: '#ececec',
                padding: '20px 0',
                display: 'inline-block',
                verticalAlign: 'top',
                width: '100%'
            }
        } >
            <Container>
                <Grid container> {/* Added spacing to make the layout clearer */}
                    <Box
                        sx={{
                            display: {
                                sm: 'flex',
                                md: 'flex'
                            },                          
                            paddingTop: '30px',
                            paddingBottom: '39px',
                            paddingLeft: { md: '18.5%' },
                            paddingRight: { md: '11%' },
                            position: 'relative',
                            alignItems: 'center',
                            // Medium screen and up (md breakpoint)
                            '@media (min-width: 992px)': {
                                
                                '&::after': {
                                    content: '""',
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%,-50%)',
                                    width: '1px',
                                    height: '80%',
                                    backgroundColor: 'rgb(0 0 0 / 80%)',
                                },
                                gap: '4rem'
                            },
                            '@media (max-width: 991px)': {
                                display: "flex",
                                flexWrap: "wrap",                                
                            },
                            gap: '4rem'
                        }}
                    >
                        {
                            quotingFooterData.map((section, index) => {
                                return (<QuotingSubmenu item={section} />)
                            })
                        }
                    </Box>

                </Grid>
            </Container>
        </Box>
    );
};

export default QuotingFooter;
